<template>
  <div class="container">
    <div class="images" data-aos="fade-right">
      <img src="/images/follow.png" alt="" class="main-screen" />
      <img src="/images/screen2.png" alt="" class="inst insta-screen-1" />
      <img src="/images/screen1.png" alt="" class="inst insta-screen-2" />
    </div>
    <div class="article" data-aos="fade-left">
      <h2 class="follow-heading">Follow us in Instagram</h2>
      <p class="follow-text">
        Be the first to know about new products and news in our world of
        clothing
      </p>
      <router-link to="/404">
        <store-button
          :border="'1.5px solid #000'"
          :padding="'8px 24px'"
          :width="'23rem'"
          :font-size="'3.4rem'"
          :color="'#000'"
          >Instagram</store-button
        >
      </router-link>
    </div>
  </div>
</template>

<style scoped>
* {
  overflow: visible !important;
}
.container {
  display: flex;
  justify-content: space-around;
  margin: 0 0 200px 0;
  padding: 60px 0;
}

.main-screen {
  max-width: 100%;
}

.images {
  position: relative;
}

.inst {
  position: absolute;
}

.insta-screen-1 {
  bottom: 40px;
  right: 100px;
}

.insta-screen-2 {
  bottom: -50px;
  left: 450px;
}

.article {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 20px;
}

.follow-heading {
  font-family: "Mabry Pro";
  font-size: 3.8rem;
  font-weight: 500;
  max-width: 24rem;
}

.follow-text {
  font-family: "Mabry Pro";
  font-size: 2.8rem;
  font-weight: 300;
  max-width: 50rem;
  margin-bottom: 100px;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  /* стили для мобильных устройств */
  .container {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 50px;
  }

  .insta-screen-2 {
    display: none;
  }
  .insta-screen-1 {
    top: 0;
    right: 100px;
    max-height: 100%;
    max-width: 300px;
  }
  .follow-text {
    margin-bottom: 20px;
  }
  .follow-heading {
    margin-top: 20px;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  /* стили для планшетов */
  .container {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 50px;
  }
  .insta-screen-2 {
    display: none;
  }
  .insta-screen-1 {
    top: 0;
    right: 100px;
    max-height: 100%;
    max-width: 300px;
  }
  .follow-text {
    margin-bottom: 20px;
  }
  .follow-heading {
    margin-top: 20px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  /* стили для ноутбуков */
  .container {
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 50px;
  }
  .insta-screen-2 {
    display: none;
  }
  .insta-screen-1 {
    top: 0;
    right: 100px;
    max-height: 100%;
    max-width: 300px;
  }
  .follow-text {
    margin-bottom: 20px;
  }
  .follow-heading {
    margin-top: 20px;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1440px) {
  /* стили для десктопов */
  .insta-screen-2 {
    display: none;
  }
}

</style>